/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-30 11:21:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-30 11:21:52
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Typography/index.tsx
 */
import { Typography } from 'antd';
const { Text, Link } = Typography;
export { Text, Link };
